/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useMemo } from "react"
import Dropdown from "react-bootstrap/Dropdown"
import { useNavigate, Link } from "react-router-dom"
import { api } from "../../utils/variables"
import { buildKeywordSearchParams, KEYWORD_SEARCH_PATH, normalizeSearchGames } from "../../utils/keywordSearch"
import axios from "axios"
import GuestRestrictedPlaceholder from "../../components/Common/GuestRestrictedPlaceholder"

import AppSearchModal from "../../additional_components/common/Modals/AppSearchModal"
import KeywordTrackingLandingPageModal from "../../components/Common/Modal/KeywordTrackingLandingPageModal"
import KeywordTrackingDetailsModal from "../../components/Common/Modal/KeywordTrackingDetailsModal"
import AppsTrackingPlanModal from "../../components/Common/Modal/AppsTrackingPlanModal"
import SkeletonCard from "./components/SkeletonCard"
import PlatformIcon from "../../components/Common/PlatformIcon"
import PlatformTabs from "../../components/Common/PlatformTabs"
import { usePlatforms } from "../../contexts/PlatformsContext"
import ConfirmRemoveTagModal from "../../components/Common/Modal/ConfirmRemoveTagModal"
import { Info, Gamepad2, Search, Plus } from "lucide-react";
import SEO from "../../components/Common/SEO"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { useAnalytics, ANALYTICS_EVENTS } from "../../analytics"


const KeywordTrackingLandingPage = () => {
  const navigate = useNavigate()
  const { trackEvent } = useAnalytics()
  const searchInputRef = useRef(null)
  const { normalizePlatformName } = usePlatforms()

  const [selectedGroup, setSelectedGroup] = useState("all")
  // Filter tracked apps/games by platform (Meta Quest / Steam / Apple Vision / etc.), default All Platforms
  const [selectedPlatform, setSelectedPlatform] = useState("all")
  // Single-select platform pill row - picking one platform replaces whatever was
  // selected before; clicking the already-active platform clears back to "all"
  // (same behavior as the home dashboard's Most Tracked Games / Top Performer
  // Apps platform pills).
  const handlePlatformToggle = (platformId) => {
    setSelectedPlatform(prev => (prev === platformId ? "all" : platformId))
  }
  const [trackedGames, setTrackedGames] = useState([])
  const [allTrackedGames, setAllTrackedGames] = useState([])
  const [groups, setGroups] = useState([])
  const [loading, setLoading] = useState(true)
  const [gamesInGroup, setGamesInGroup] = useState([])
  const [showCreateGroupModal, setShowCreateGroupModal] = useState(false)
  const [groupNameInput, setGroupNameInput] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false) // set true initially to see the modal
  const [showAppSearchModal, setShowAppSearchModal] = useState(false)
  const [createdGroupName, setCreatedGroupName] = useState("")
  const [hoveredButtonIndex, setHoveredButtonIndex] = useState(null)
  const [isHovered, setIsHovered] = useState(false)
  const [hoveredIndex, setHoveredIndex] = useState(null)
  // track hovered row and hovered button type
  const [hoveredRow, setHoveredRow] = useState(null) // row index
  const [hoveredButton, setHoveredButton] = useState(null)
  const [skeletonCount, setSkeletonCount] = useState(0)
  const [tagInput, setTagInput] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [showDetailsModal, setDetailsShowModal] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [activeGroup, setActiveGroup] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [gameToDelete, setGameToDelete] = useState(null)
  const [filteredGames, setFilteredGames] = useState([]) // Add this for filtered games
  const [isAllGamesHovered, setIsAllGamesHovered] = useState(false)
  const [dragOverGroup, setDragOverGroup] = useState(null)

  // Upgrade modal state
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false)
  const [showGroupDeleteModal, setShowGroupDeleteModal] = useState(false)
  const [groupToDelete, setGroupToDelete] = useState(null)
  const [resolving, setResolving] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const indexOfLastGame = currentPage * itemsPerPage;
  const indexOfFirstGame = indexOfLastGame - itemsPerPage;

  // Identify if current session is browsing as a Guest
  const isGuest = useMemo(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"))
      return (
        authUser?.data?.is_guest === true || authUser?.is_guest === true
      )
    } catch (_) {
      return false
    }
  }, [])

  // Sort games: unlocked apps first, then locked apps
  const sortedFilteredGames = [...filteredGames]
    .filter(game => selectedPlatform === "all" || normalizePlatformName(game.platform) === selectedPlatform)
    .sort((a, b) => {
    // If both are locked or both are unlocked, maintain original order
    if ((a.is_locked || false) === (b.is_locked || false)) {
      return 0;
    }
    // Unlocked apps (is_locked: false/undefined) come first
    return (a.is_locked || false) ? 1 : -1;
  });

  const currentGames = sortedFilteredGames.slice(indexOfFirstGame, indexOfLastGame);


  // Upgrade error detection functions
  const isUpgradeError = error => {
    const response = error?.response
    const data = response?.data || {}
    const message = data?.message || ""
    const action = data?.action || ""
    return (
      response?.status === 400 &&
      (action === "UPGRADE" || /max limit/i.test(message))
    )
  }

  const isUpgradeResponse = data => {
    if (!data || typeof data !== "object") return false
    const message = data?.message || ""
    const action = data?.action || ""
    const status = data?.status
    return (
      status === 400 && (action === "UPGRADE" || /max limit/i.test(message))
    )
  }

  // Create Tag
  const [createTag, setCreateTag] = useState(null)

  // "view"|"drag"|"delete"

  // factory that knows both index & type
  const btnStyle = (rowIdx, type) => ({
    width: "44px",
    height: "44px",
    borderRadius: "12px",
    background:
      hoveredRow === rowIdx && hoveredButton === type ? "#3A3C46" : "#2A2C38",
    border: "none",
    cursor: type === "drag" ? "grab" : "pointer",
    color: type === "delete" ? "#F6255A" : "#FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.2s ease",
  })

  const [showModal, setShowModal] = useState(false)
  const [gameToMove, setGameToMove] = useState(null)

  const handleOpen = game => {
    setGameToMove(game)
    setShowModal(true)
  }
  const handleClose = () => {
    setShowModal(false)
    setGameToMove(null)
  }

  useEffect(() => {
    // show cached groups immediately for snappier UI, then refresh from server
    try {
      const cached = JSON.parse(localStorage.getItem('keywordGroups') || 'null')
      if (Array.isArray(cached) && cached.length > 0) {
        setGroups(cached)
      }
    } catch (err) { }
    // fetch canonical data after showing cache. We intentionally don't add
    // the functions to the dependency array because they are stable here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // callAppTrackapi()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    getGameTags()
  }, [])

  useEffect(() => {
    fetchUserTrackedKeywords()
    // fetchGroups()
  }, [])

  // Initialize filteredGames when trackedGames changes and no group is selected
  useEffect(() => {
    if (!activeGroup && trackedGames.length > 0) {
      setFilteredGames(trackedGames)
    }
  }, [trackedGames, activeGroup])

  // Add filtering effect based on activeGroup
  useEffect(() => {
    filterGamesByGroup()
    setCurrentPage(1) // Reset to first page when group changes
  }, [activeGroup, trackedGames, groups])

  // Reset to first page when the platform filter changes
  useEffect(() => {
    setCurrentPage(1)
  }, [selectedPlatform])

  // Listen for keyword group updates
  useEffect(() => {
    const handleKeywordGroupsUpdated = () => {
      getGameTags()
      fetchUserTrackedKeywords()
    }

    window.addEventListener("keywordGroupsUpdated", handleKeywordGroupsUpdated)

    return () => {
      window.removeEventListener(
        "keywordGroupsUpdated",
        handleKeywordGroupsUpdated
      )
    }
  }, [])

  // Function to filter games based on active group
  const filterGamesByGroup = () => {
    if (!activeGroup) {
      setFilteredGames(trackedGames)
      return
    }

    const selectedGroup = groups.find(group => group.name === activeGroup)

    if (selectedGroup && selectedGroup.game_ids && trackedGames.length > 0) {
      const groupIds = selectedGroup.game_ids.map(String) // normalize to string
      const filtered = trackedGames.filter(
        game => groupIds.includes(String(game.item_id)) // normalize item_id too
      )
      setFilteredGames(filtered)
    } else if (
      selectedGroup &&
      (!selectedGroup.game_ids || selectedGroup.game_ids.length === 0)
    ) {
      setFilteredGames([])
    } else {
      setFilteredGames(trackedGames)
    }
  }


  const fetchUserTrackedKeywords = async (skipCache = false) => {
    try {
      // 1. Try to load from cache first (unless skipCache is true)
      if (!skipCache) {
        const cachedData = localStorage.getItem("userTrackedKeywords")
        if (cachedData) {
          const parsedData = JSON.parse(cachedData)
          if (parsedData && Array.isArray(parsedData)) {
            // Sort cached data DESC by tracked_on
            const sortedData = [...parsedData].sort((a, b) => new Date(b.tracked_on || 0) - new Date(a.tracked_on || 0))
            setTrackedGames(sortedData)
            if (!activeGroup) {
              setFilteredGames(sortedData)
            }
            setLoading(false) // Show cached data immediately
          }
        }
      } else {
        setLoading(true) // Always show loading when skipping cache
      }

      // 2. Fetch fresh data from API
      const response = await axios.get(
        `${api}/tracker/tracking/get_user_tracked_keywords`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Accept: "application/json, text/plain, */*",
          },
        }
      )

      if (isUpgradeResponse(response.data)) {
        setShowUpgradeModal(true)
        setDetailsShowModal(false)
        setShowCreateGroupModal(false)
        return
      }

      if (response.data.status) {
        const g_data = response.data.data.game_data

        // Sort fresh data DESC by tracked_on
        const sortedData = [...(g_data || [])].sort((a, b) => new Date(b.tracked_on || 0) - new Date(a.tracked_on || 0))

        // WORKAROUND: Filter out games that were marked as deleted but backend still returns
        // This handles the case where backend deletion has a delay or doesn't work properly
        const deletedGamesList = JSON.parse(localStorage.getItem("persistentlyDeletedGames") || "[]")
        
        if (deletedGamesList.length > 0) {
          const filteredData = sortedData.filter(game => !deletedGamesList.includes(game.item_id))
          
          // Use the filtered data instead of raw API data
          if (filteredData.length < sortedData.length) {
            setTrackedGames(filteredData)
            if (!activeGroup) {
              setFilteredGames(filteredData)
            }
            localStorage.setItem("userTrackedKeywords", JSON.stringify(filteredData))
            return
          }
        }

        // WORKAROUND: If we have a recently deleted game ID, manually filter it out
        // This handles the case where backend deletion has a delay
        const recentlyDeletedGameId = localStorage.getItem("recentlyDeletedGameId")
        if (recentlyDeletedGameId) {
          const filteredData = sortedData.filter(game => game.item_id !== recentlyDeletedGameId)
          
          // Use the filtered data instead of raw API data
          if (filteredData.length < sortedData.length) {
            
            // Add to persistent list so it survives page refresh
            const updatedDeletedList = [...deletedGamesList, recentlyDeletedGameId]
            localStorage.setItem("persistentlyDeletedGames", JSON.stringify(updatedDeletedList))
            localStorage.removeItem("recentlyDeletedGameId") // Clean up temporary
            
            setTrackedGames(filteredData)
            if (!activeGroup) {
              setFilteredGames(filteredData)
            }
            localStorage.setItem("userTrackedKeywords", JSON.stringify(filteredData))
            return
          }
        }

        // Update state with fresh sorted data
        setTrackedGames(sortedData)
        if (!activeGroup) {
          setFilteredGames(sortedData)
        }

        // Update cache with sorted data
        localStorage.setItem("userTrackedKeywords", JSON.stringify(sortedData))
      }
    } catch (error) {
      console.error("Error fetching tracked keywords:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
        setDetailsShowModal(false)
        setShowCreateGroupModal(false)
      }
    } finally {
      setLoading(false)
    }
  }
  const handleSearch = async () => {
    if (!searchTerm.trim()) return

    setLoading(true)
    trackEvent(ANALYTICS_EVENTS.FEATURE.KEYWORD_TRACKING_SEARCH, { keyword: searchTerm, platform: selectedPlatform })
    try {
      const params = new URLSearchParams(buildKeywordSearchParams(searchTerm))
      const response = await axios.get(
        `${api}${KEYWORD_SEARCH_PATH}?${params.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )

      if (isUpgradeResponse(response.data)) {
        setShowUpgradeModal(true)
        setDetailsShowModal(false)
        setShowCreateGroupModal(false)
        setSearchResults([])
        return
      }

      setSearchResults(normalizeSearchGames(response.data?.games || []))
    } catch (error) {
      console.error("Search failed:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
        setDetailsShowModal(false)
        setShowCreateGroupModal(false)
      }
      setSearchResults([])
    } finally {
      setLoading(false)
    }
  }

  // NOTE: fetchGroups removed (use getGameTags instead)

  // const callAppTrackapi = async () => {
  //   await axios
  //     .get(`${api}/tracker/tracking/app`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //       },
  //     })
  //     .then(res => {
  //       if (isUpgradeResponse(res.data)) {
  //         setShowUpgradeModal(true)
  //         setDetailsShowModal(false)
  //         setShowCreateGroupModal(false)
  //         return
  //       }
  //       console.log("trackedGames", trackedGames)
  //       setAllTrackedGames(res.data.games)
  //       console.log("allTrackedGames", allTrackedGames)

  //       //adding data in session item
  //       sessionStorage.setItem(
  //         "comparisonBetween",
  //         JSON.stringify(res.data.games)
  //       )
  //     })
  //     .catch(error => {
  //       console.error("Error fetching app data:", error)
  //       if (isUpgradeError(error)) {
  //         setShowUpgradeModal(true)
  //         setDetailsShowModal(false)
  //         setShowCreateGroupModal(false)
  //       }
  //     })
  //   setLoading(false)
  // }

  const createGroupApi = async gameWithGroup => {
    setLoading(true)
    const payload = {
      ...gameWithGroup,
      tag_type: "KEYWORD",
    }
    await axios
      .post(`${api}/tracker/tags.keywords/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then(res => {
        if (isUpgradeResponse(res.data)) {
          setShowUpgradeModal(true)
          setDetailsShowModal(false)
          setShowCreateGroupModal(false)
          return
        }
        getGameTags()
        setIsModalOpen(false)
      })
      .catch(error => {
        console.error("Error creating group:", error)
        if (isUpgradeError(error)) {
          setShowUpgradeModal(true)
          setDetailsShowModal(false)
          setShowCreateGroupModal(false)
        }
      })
    setLoading(false)
  }

  // Create an empty group immediately (optimistic) so user sees it right away
  const createEmptyGroup = async tagName => {
    if (!tagName) return

    // Check for duplicate group name
    const isDuplicate = groups.find(g => g.name === tagName)
    if (isDuplicate) {
      toastr.error(`Group "${tagName}" already exists`)
      return
    }

    // optimistic UI update: add empty group if not present
    setGroups(prev => {
      if (prev.find(g => g.name === tagName)) return prev
      const next = [...prev, { name: tagName, game_ids: [] }]
      try {
        localStorage.setItem('keywordGroups', JSON.stringify(next))
      } catch (e) { }
      return next
    })

    try {
      const payload = { tag_name: tagName, tag_type: "KEYWORD" }
      const res = await axios.post(`${api}/tracker/tags.keywords/`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      })
      if (isUpgradeResponse(res.data)) {
        setShowUpgradeModal(true)
        return
      }
      await getGameTags()
      triggerToast(`Group "${tagName}" created successfully`)
    } catch (err) {
      console.error('Error creating empty group:', err)
      if (isUpgradeError(err)) {
        setShowUpgradeModal(true)
      } else {
        toastr.error(`Failed to create group "${tagName}"`)
      }
    }
  }

  const getGameTags = () => {
    axios
      .get(`${api}/tracker/tags.keywords?tag_type=KEYWORD`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then(res => {
        if (isUpgradeResponse(res.data)) {
          setShowUpgradeModal(true)
          setDetailsShowModal(false)
          setShowCreateGroupModal(false)
          return
        }
        setGroups(res.data.data)
        try {
          localStorage.setItem('keywordGroups', JSON.stringify(res.data.data))
        } catch (err) {
          // ignore
        }
      })
      .catch(error => {
        console.error("Error fetching game tags:", error)
        if (isUpgradeError(error)) {
          setShowUpgradeModal(true)
          setDetailsShowModal(false)
          setShowCreateGroupModal(false)
        }
      })
  }
  // Small toast helper (uses toastr if available)
  const triggerToast = msg => {
    try {
      toastr.success(msg)
    } catch (err) {
      console.log("Toast:", msg)
    }
  }

  // drag refs for potential drag->group moves
  const draggedItemId = useRef(null)
  const dragSourceGroup = useRef(null)
  const isDraggingCardRef = useRef(false)
  // suppress duplicate toasts when moving an item between groups
  const moveToastSuppress = useRef(new Map())
  // When user clicks Track while in create-group mode, remember the target group
  // so that after the user tracks the keyword on the details page we can add it
  // into the newly created group automatically.
  const pendingAddToGroupRef = useRef(null)

  // Create or add a single item to a keyword tag (optimistic update)
  const createNewGameTag = async (itemID, tagName, suppressToast = false) => {
    if (!itemID || !tagName || tagName === "all") return
    try {
      // ensure item is tracked before adding to tag (mirrors AppTracking flow)
      // try {
      //   await ensureAppTracked(itemID)
      // } catch (err) {
      //   // if tracking failed or upgrade required, abort adding to tag
      //   console.error('Could not ensure item tracked before tagging', err)
      //   return
      // }
      const payload = {
        item_id: itemID,
        tag_name: tagName,
        tag_type: "KEYWORD",
      }

      // optimistic UI update
      setGroups(prev => {
        const found = prev.find(g => g.name === tagName)
        if (found) {
          if (!found.game_ids) found.game_ids = []
          if (!found.game_ids.map(String).includes(String(itemID))) {
            return prev.map(g =>
              g.name === tagName ? { ...g, game_ids: [...g.game_ids, itemID] } : g
            )
          }
          return prev
        } else {
          return [...prev, { name: tagName, game_ids: [itemID] }]
        }
      })

      const res = await axios.post(`${api}/tracker/tags.keywords/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })

      if (isUpgradeResponse(res.data)) {
        setShowUpgradeModal(true)
        return
      }

      await getGameTags()
      // If this add was part of a drag-move, suppress the duplicate "Added" toast
      let suppressedByMove = false
      try {
        const m = moveToastSuppress.current
        if (m && m.get && m.get(String(itemID)) === tagName) {
          suppressedByMove = true
          m.delete(String(itemID))
        }
      } catch (e) {
        // ignore
      }

      if (!suppressToast && !suppressedByMove) triggerToast(`Added to ${tagName}`)
    } catch (error) {
      console.error("Error adding to tag:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
      } else {
        toastr.error(`Failed to add to ${tagName}`)
      }
    }
  }

  // Remove a game from a tag (optimistic)
  const deleteGamefromTag = async (item, tag) => {
    if (!item || !tag) return
    try {
      setGroups(prev =>
        prev.map(g =>
          g.name === tag
            ? { ...g, game_ids: (g.game_ids || []).filter(id => String(id) !== String(item)) }
            : g
        )
      )

      const payload = {
        item_id: item,
        tag_name: tag,
        tag_type: "KEYWORD",
      }

      const res = await axios.patch(
        `${api}/tracker/tags.keywords/${encodeURIComponent(tag)}/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )

      if (isUpgradeResponse(res.data)) {
        setShowUpgradeModal(true)
        return
      }

      await getGameTags()
    } catch (error) {
      console.error("Error removing from tag:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
      }
    }
  }

  // Wrapper used by modal to add a single item to tag, then refresh tracked lists
  const handleAddSingleToTag = async (itemId, tagName) => {
    if (!itemId || !tagName) return
    try {
      await createNewGameTag(itemId, tagName)
      await getGameTags()
      // await callAppTrackapi()
      setGamesInGroup([])
    } catch (error) {
      console.error("handleAddSingleToTag failed:", error)
      if (isUpgradeError(error)) setShowUpgradeModal(true)
    }
  }

  // Bulk add multiple items to a tag
  const handleBulkAddToTag = async (itemIds, tagName) => {
    if (!Array.isArray(itemIds) || !tagName) return
    try {
      await Promise.all(itemIds.map(id => createNewGameTag(id, tagName)))
      await getGameTags()
      // await callAppTrackapi()
      setGamesInGroup([])
    } catch (error) {
      console.error("Bulk add failed:", error)
      if (isUpgradeError(error)) setShowUpgradeModal(true)
    }
  }

  // Modal-remove handler: remove from tag or untrack if tagName omitted
  const handleModalRemoveFromTag = async (itemId, tagName = null) => {
    try {
      if (tagName) {
        await deleteGamefromTag(itemId, tagName)
        await getGameTags()
      } else {
        await axios.post(
          `${api}/tracker/tracking/remove_entity`,
          {
            game_id: itemId,
            entity_type: "keyword",
            entity_id: null,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "Content-Type": "application/json",
            },
          }
        )
        
        // Remove the deleted app from compared_tracked_app_ids to update badge status in KeywordSuggestions
        try {
          const comparedTrackedAppIds = JSON.parse(localStorage.getItem('compared_tracked_app_ids') || '[]')
          const updatedAppIds = comparedTrackedAppIds.filter(id => String(id) !== String(itemId))
          localStorage.setItem('compared_tracked_app_ids', JSON.stringify(updatedAppIds))
          
          // Dispatch event to notify KeywordSuggestions page to refresh its tracking status
          window.dispatchEvent(new CustomEvent('keywordTrackingUpdated', { detail: { deletedAppId: itemId } }))
        } catch (e) {
          console.error("Error clearing compared_tracked_app_ids:", e)
        }
        
        await fetchUserTrackedKeywords()
      }
    } catch (error) {
      console.error("remove from modal failed:", error)
      if (isUpgradeError(error)) setShowUpgradeModal(true)
    }
  }

  // Ensure app is tracked (used by modal selection / track-then-tag flows)
  // const ensureAppTracked = async item => {
  //   const trackedIds = (allTrackedGames || []).map(g => String(g.game_details?.item_id || g.item_id || ""))
  //   const idStr = String(item.item_id || item.game_details?.item_id || item)
  //   if (trackedIds.includes(idStr)) return
  //   try {
  //     const res = await axios.post(
  //       `${api}/tracker/tracking/app/`,
  //       { item_id: item.item_id || item },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     )
  //     if (isUpgradeResponse(res.data)) {
  //       setShowUpgradeModal(true)
  //       return
  //     }
  //     await callAppTrackapi()
  //   } catch (err) {
  //     console.error("Error tracking app:", err)
  //     if (isUpgradeError(err)) setShowUpgradeModal(true)
  //     throw err
  //   }
  // }

  // Modal selection handler (track-then-tag / create-group behavior)
  const handleselectedapp = async app => {
    try {
      // If there is a pending group target (Add button was used), prefer
      // adding directly when the app is already tracked; otherwise keep the
      // pending ref and send the user to details so they can track the app.
      if (pendingAddToGroupRef.current) {
        const target = pendingAddToGroupRef.current
        const appId = app.item_id || app.itemId || app
        if (trackedIds.includes(String(appId))) {
          // already tracked — add immediately
          try {
            await createNewGameTag(appId, target)
            await getGameTags()
            // await callAppTrackapi()
          } catch (err) {
            console.error('Auto add to pending group failed', err)
            if (isUpgradeError(err)) setShowUpgradeModal(true)
          }
          pendingAddToGroupRef.current = null
          setDetailsShowModal(false)
          return
        }

        // not tracked yet — keep pending ref and navigate to details so user
        // can track the app; the existing keywordTracked listener will add
        // the item into the pending group after tracking.
        setDetailsShowModal(false)
        navigate(`/xr/keyword/${(app.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}?id=${app.item_id}`, { state: { item_id: app.item_id } })
        return
      }

      if (createTag) {
        // create-group mode: behave the same as before
        pendingAddToGroupRef.current = createTag
        setDetailsShowModal(false)

        // Clear local storage for this app before navigating to ensure clean state
        try {
          const prefix = `keyword_tracking_${app.item_id}_`
          Object.keys(localStorage).forEach(key => {
            if (key.startsWith(prefix)) {
              localStorage.removeItem(key)
            }
          })
        } catch (e) {
          console.error("Error clearing cleanup storage:", e)
        }

        navigate(`/xr/keyword/${(app.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}?id=${app.item_id}`, { state: { item_id: app.item_id } })
      } else {
        // normal: redirect to details so user can track there
        setDetailsShowModal(false)

        // Clear local storage for this app before navigating to ensure clean state
        try {
          const prefix = `keyword_tracking_${app.item_id}_`
          Object.keys(localStorage).forEach(key => {
            if (key.startsWith(prefix)) {
              localStorage.removeItem(key)
            }
          })
        } catch (e) {
          console.error("Error clearing cleanup storage:", e)
        }

        navigate(`/xr/keyword/${(app.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}?id=${app.item_id}`, { state: { item_id: app.item_id } })
      }
    } catch (err) {
      console.error("handleselectedapp failed:", err)
      if (isUpgradeError(err)) setShowUpgradeModal(true)
    }
  }

  // Listen for tracking events from detail page so we can refresh tags/tracked lists.
  useEffect(() => {
    const onKeywordTracked = async e => {
      try {
        const itemId = e?.detail?.item_id || e?.detail?.itemId || null

        // Refresh tracked apps first
        // await callAppTrackapi()

        // If there is a pending create-group target, add this tracked item into that group
        if (pendingAddToGroupRef.current && itemId) {
          try {
            await createNewGameTag(itemId, pendingAddToGroupRef.current)
          } catch (err) {
            console.error('Auto add to pending group failed', err)
          }
          // clear pending target and any create-mode UI state
          pendingAddToGroupRef.current = null
          setCreateTag(null)
          setDetailsShowModal(false)
        }

        // Refresh tags and keyword tracking lists
        await getGameTags()
        await fetchUserTrackedKeywords()
      } catch (err) {
        console.error("Refresh after keyword tracked failed:", err)
      }
    }

    window.addEventListener("keywordTracked", onKeywordTracked)
    return () => window.removeEventListener("keywordTracked", onKeywordTracked)
  }, [])

  // Drag handlers (lightweight)
  // eslint-disable-next-line no-unused-vars
  const handleDragStart = (e, itemId, sourceGroupName = null) => {
    draggedItemId.current = itemId
    dragSourceGroup.current = sourceGroupName
  }

  // eslint-disable-next-line no-unused-vars
  const handleDropOnGroup = async (e, targetGroupName) => {
    if (e?.preventDefault) e.preventDefault()
    const itemId = draggedItemId.current
    if (!itemId || !targetGroupName) return
    try {
      if (dragSourceGroup.current === targetGroupName) return

      const targetGroup = groups.find(group => group.name === targetGroupName)
      const alreadyInTarget = targetGroup?.game_ids
        ?.map(String)
        .includes(String(itemId))
      if (alreadyInTarget) {
        triggerToast(`App already in ${targetGroupName}`)
        return
      }

      const addPromise = createNewGameTag(itemId, targetGroupName, true)
      setActiveGroup(targetGroupName)
      await addPromise

      triggerToast(`Added app to ${targetGroupName}`)
    } catch (err) {
      console.error("drag drop to group failed:", err)
      if (isUpgradeError(err)) setShowUpgradeModal(true)
    } finally {
      draggedItemId.current = null
      dragSourceGroup.current = null
      setDragOverGroup(null)
      isDraggingCardRef.current = false
    }
  }

  const handleGroupDragEnter = (e, groupName) => {
    e.preventDefault()
    setDragOverGroup(groupName)
  }

  const handleGroupDragOver = (e, groupName) => {
    e.preventDefault()
    if (dragOverGroup !== groupName) {
      setDragOverGroup(groupName)
    }
  }

  const handleGroupDragLeave = e => {
    e.preventDefault()
    setDragOverGroup(null)
  }

  const handleGroupDropZone = (e, groupName) => {
    e.preventDefault()
    setDragOverGroup(null)
    handleDropOnGroup(e, groupName)
  }

  const handleCardDragStart = (e, game) => {
    if (!game?.item_id) return
    isDraggingCardRef.current = true
    try {
      e.dataTransfer.effectAllowed = "copy"
      e.dataTransfer.setData("text/plain", String(game.item_id))
      const imgEl =
        e.currentTarget?.querySelector(".char_inner_box_lt_img img") || null
      if (imgEl) {
        const rect = imgEl.getBoundingClientRect()
        e.dataTransfer.setDragImage(imgEl, rect.width / 2, rect.height / 2)
      }
    } catch (err) { }
    handleDragStart(e, game.item_id, activeGroup || null)
  }

  const handleCardDragEnd = () => {
    isDraggingCardRef.current = false
    draggedItemId.current = null
    dragSourceGroup.current = null
    setDragOverGroup(null)
  }

  const handleCardClick = (e, game) => {

    if (e.target.closest("[data-stop-card-click]")) {
      return
    }

    if (isDraggingCardRef.current) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    navigate(`/xr/keyword/${(game.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}?id=${game.item_id}`, { state: { item_id: game.item_id } })
  }

  // trackedIds passed to modal so it can show Add-to-Tag when an app is already tracked
  const trackedIds = useMemo(
    () =>
      (trackedGames || []).map(g => String(g.game_details?.item_id || g.item_id || "")),
    [trackedGames]
  )

  // eslint-disable-next-line no-unused-vars
  const toTitleCase = str =>
    str.replace(
      /\w\S*/g,
      txt => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
    )

  const alreadySelectedGames = allTrackedGames.map(game => ({
    name: game.game_details?.name || "",
    image_url: game.game_details?.image_url || "",
    item_id: game.game_details?.item_id || "",
    platform: game.game_details?.platform || "",
  }))

  // eslint-disable-next-line no-unused-vars
  const groupButtonStyle = (label, isHovered) => {
    const labelText = typeof label === "string" ? label : label.name
    const screenWidth = window.innerWidth
    const widthBase = screenWidth > 1400 ? 140 : screenWidth > 1024 ? 130 : 120
    const heightBase = screenWidth > 1400 ? 48 : screenWidth > 1024 ? 44 : 40

    const isSelected =
      selectedGroup === label || selectedGroup?.name === labelText

    const baseColor = isSelected ? "#F6255A" : "#171821"
    const hoverColor = isSelected ? "#e11d4c" : "#2A2C38" // lighter on hover

    return {
      width:
        labelText === "+ Create Groups"
          ? `${widthBase + 10}px`
          : labelText.length > 12
            ? `${widthBase + 20}px`
            : `${widthBase}px`,
      height: `${heightBase}px`,
      borderRadius: "12px",
      padding: "10px 16px",
      background: isHovered ? hoverColor : baseColor,
      color: "#FFFFFF",
      fontFamily: "Rubik, sans-serif",
      fontWeight: "500",
      fontSize: "14px",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: labelText === "+ Create Groups" ? "8px" : "0px",
      transition: "all 0.2s ease-in-out",
    }
  }
  const addButtonStyle = {
    width: "84px",
    padding: "8px 16px",
    borderRadius: "6px",
    background: isHovered ? "#e11d4c" : "#F6255A", // lighter on hover
    color: "#FFFFFF",
    border: "none",
    fontWeight: "500",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background 0.2s ease-in-out",
  }
  // Custom skeleton card
  const handleRemoveGame = async game => {
    console.log("🗑️ Starting deletion for game:", game.name, game.item_id)
    try {
      setLoading(true)
      console.log("📡 Making API call to delete game...")
      const response = await axios.post(
        `${api}/tracker/tracking/remove_entity`,
        {
          game_id: game.item_id, // Make sure this is correct
          entity_type: "keyword",
          entity_id: null,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "application/json",
          },
        }
      )

      console.log("📥 API response received:", response.data)

      if (isUpgradeResponse(response.data)) {
        console.log("⚠️ Upgrade response detected")
        setShowUpgradeModal(true)
        setDetailsShowModal(false)
        setShowCreateGroupModal(false)
        return
      }

      // Check if deletion was successful
      if (response.data && response.data.status === 200) {
        console.log("✅ Deletion successful!")
        // Store deleted game ID for workaround in case backend has delay
        localStorage.setItem("recentlyDeletedGameId", game.item_id)
        console.log("💾 Stored deleted game ID for workaround:", game.item_id)
        // Show success notification
        toastr.success(`"${game.name}" removed successfully`)
      } else {
        // Handle unexpected response
        console.error("❌ Unexpected response:", response.data)
        toastr.error("Unexpected response from server")
        return
      }

      // Clear local storage for this app to prevent zombie data resurrection
      try {
        console.log("🧹 Clearing local storage...")
        const prefix = `keyword_tracking_${game.item_id}_`
        const keysToRemove = []
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith(prefix)) {
            keysToRemove.push(key)
            localStorage.removeItem(key)
          }
        })
        console.log("🗑️ Removed localStorage keys:", keysToRemove)
        
        // IMPORTANT: Also clear the userTrackedKeywords cache to prevent showing deleted app
        const cacheCleared = localStorage.removeItem("userTrackedKeywords")
        console.log("🗑️ Cleared userTrackedKeywords cache:", cacheCleared === undefined)

        // IMPORTANT: Remove the deleted app from compared_tracked_app_ids to update badge status in KeywordSuggestions
        try {
          const comparedTrackedAppIds = JSON.parse(localStorage.getItem('compared_tracked_app_ids') || '[]')
          const updatedAppIds = comparedTrackedAppIds.filter(id => String(id) !== String(game.item_id))
          localStorage.setItem('compared_tracked_app_ids', JSON.stringify(updatedAppIds))
          console.log("🗑️ Removed app ID from compared_tracked_app_ids:", game.item_id)
          
          // Dispatch event to notify KeywordSuggestions page to refresh its tracking status
          window.dispatchEvent(new CustomEvent('keywordTrackingUpdated', { detail: { deletedAppId: game.item_id } }))
        } catch (e) {
          console.error("❌ Error clearing compared_tracked_app_ids:", e)
        }
      } catch (e) {
        console.error("❌ Error clearing cleanup storage:", e)
      }

      console.log("🔄 Fetching fresh data...")
      await fetchUserTrackedKeywords(true) // Skip cache to get fresh data
      console.log("✅ Fresh data fetch completed")
    } catch (error) {
      console.error("❌ Remove failed:", error)
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
        setDetailsShowModal(false)
        setShowCreateGroupModal(false)
      } else {
        toastr.error("Failed to remove tracked game")
      }
    } finally {
      setLoading(false)
      console.log("🏁 Deletion process completed")
    }
  }
  const handleRemoveGroup = async groupName => {
    try {
      const response = await fetch(
        `${api}/tracker/tags.keywords/${groupName}/?tag_type=KEYWORD`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error(`Failed to delete group: ${response.statusText}`)
      }

      // Update UI only if API call succeeded
      setGroups(prevGroups => prevGroups.filter(g => g.name !== groupName))

      if (activeGroup === groupName) {
        setActiveGroup(null)
        setFilteredGames(trackedGames) // Reset if active group was deleted
      }

      triggerToast(`Group "${groupName}" deleted successfully`)
    } catch (error) {
      console.error("Error deleting group:", error)
      toastr.error(`Failed to delete group "${groupName}"`)
    }
  }

  const averageChange = (game) => {
    const list = game.tracked_keywords || [];
    if (list.length === 0) return 0;

    const sum = list.reduce((acc, k) => acc + (k.rank_change || 0), 0);
    return Math.round(sum / list.length);
  };



  return (
    <React.Fragment>
      <SEO title="Keyword Tracking" description="Monitor keyword rankings and performance." />
      <div className="page-content m-3 dashboard-responsive">
        <div>
          <div className="col-sm-12">
            <h3 className="mb-3 d-flex align-items-center justify-content-between">
              <span
                style={{
                  fontFamily: "Rubik",
                  fontWeight: 600,
                  fontSize: "32px",
                  color: "#fff",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                Keyword Tracking
                {/* <MaintenanceBadge
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginLeft: 8,
                    padding: "4px 8px",
                    fontSize: 12,
                    borderRadius: 6,
                    background: "rgba(255,165,0,0.95)",
                    color: "#111",
                    boxShadow: "0 1px 6px rgba(0,0,0,0.12)",
                    zIndex: 2,
                  }}
                >
                  Under Maintenance
                </MaintenanceBadge> */}
              </span>
            </h3>
            <div className="keyword_subhead">
              Track keywords for your games and apps to analyze their
              performance across revenue, downloads, and other key metrics.
              Understand how your app ranks for specific keywords across
              countries and optimize your presence in the Meta, Steam, and
              Apple Vision stores.
            </div>
          </div>


          {/* `.key_track_sec` (app.scss) fixes height:80vh / min-height:1072px,
              which is sized for pages with a lot of content - with only a
              couple of tracked apps that leaves a huge dead area below the
              list and pagination. Inline styles beat the class here (no
              `!important` on the rule) so this page can size to its actual
              content instead. */}
          <div className="key_track_sec" style={{ height: "auto", minHeight: 0 }}>
            {/* Common Left Margin Container */}

            <div
              className="d-flex align-items-center justify-content-between flex-wrap gap-2"
              style={{ marginBottom: "8px" }}
            >
              <h4 style={{ margin: 0 }}>Tracked Apps & Keywords</h4>

              <button
                onClick={() => navigate("/app-tracking")}
                disabled={resolving}
                className="go-to-publisher-btn"
                aria-label="Go to App Tracking page"
              >
                {resolving ? (
                  <span className="go-loading">Opening...</span>
                ) : (
                  <>
                    <svg
                      className="go-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M12 2L12 12M5 9L12 16L19 9"
                        stroke="#fff"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="go-label">Looking for App Tracking?</span>
                  </>
                )}
              </button>
            </div>

            <p
              className="note-text"
              style={{
                fontStyle: "italic",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <Info size={16} color="#A1ACB8" />
              Track an app first, and then track its related keywords for deeper
              insights.
            </p>

            <div className="key_track_search d-flex align-items-center flex-row gap-3 gap-sm-4">
              <div className="key_track_search_inn searchField d-flex align-items-center">
                <i className="fa-solid fa-magnifying-glass"></i>
                <input
                  ref={searchInputRef}
                  type="text"
                  placeholder="Enter App or Game Name or URL"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      handleSearch()
                      setDetailsShowModal(true)
                    }
                  }}
                />
              </div>
              <button
                className="searchBtn"
                onClick={() => {
                  handleSearch() // ✅ Call the API
                  setDetailsShowModal(true) // ✅ Then show modal
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={addButtonStyle}
              >
                Search
              </button>
            </div>

            <div
              className="custom_grp_sec"
              style={{
                // maxHeight: "calc(100vh - 100px)", // adjust based on header/footer
                overflowY: "auto",
                paddingBottom: "20px",
              }}
            >
              <p
                className="disclaimer-text"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontStyle: "italic",
                }}
              >
                <Info size={16} color="#A1ACB8" />
                These are your tracked apps and games. Click on any app below to
                go directly to its keyword tracking page.
              </p>

              {/* FIRST ROW — ALL GAMES */}
              <ul
                style={{
                  display: "flex",
                  gap: 10,
                  flexWrap: "wrap",
                  marginBottom: 14,
                }}
              >
                <li>
                  <button
                    onClick={() => {
                      setActiveGroup(null)
                      setFilteredGames(trackedGames)
                    }}
                    className={!activeGroup ? "active" : ""}
                    onMouseEnter={() => setIsAllGamesHovered(true)}
                    onMouseLeave={() => setIsAllGamesHovered(false)}
                    style={{
                      width: "auto",
                      padding: "8px 12px",
                      borderRadius: 8,
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: 700,
                      background: !activeGroup
                        ? isAllGamesHovered
                          ? "#e11d4c"
                          : "#F6255A" // ACTIVE (red)
                        : "#2A2B36", // INACTIVE (gray)

                      color: !activeGroup ? "#FFFFFF" : "#A1ACB8",

                      border: "none",

                      boxShadow: !activeGroup
                        ? isAllGamesHovered
                          ? "0 8px 24px rgba(246,37,90,0.16)"
                          : "0 6px 20px rgba(246,37,90,0.12)"
                        : "none",
                      transition: "background 0.18s ease, transform 0.12s ease",
                    }}
                    aria-label="Show all apps and games"
                  >
                    <i
                      className="fa-solid fa-th-large"
                      style={{ marginRight: 8, fontSize: 12 }}
                      aria-hidden="true"
                    ></i>
                    All Apps and Games
                  </button>
                </li>
              </ul>

              <h6
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>Custom Groups</span>
              </h6>
              {/* SECOND ROW — CUSTOM GROUPS */}
              <ul
                style={{
                  display: "flex",
                  gap: 10,
                  flexWrap: "wrap",
                  marginTop: 10,
                }}
              >
                {groups.map((group, idx) => {
                  const isDragTarget = dragOverGroup === group.name
                  return (
                    <li
                      key={idx}
                      onDragEnter={e => handleGroupDragEnter(e, group.name)}
                      onDragOver={e => handleGroupDragOver(e, group.name)}
                      onDragLeave={handleGroupDragLeave}
                      onDrop={e => handleGroupDropZone(e, group.name)}
                    >
                      <a
                        className={activeGroup === group.name ? "active" : ""}
                        onClick={() => setActiveGroup(group.name)}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "6px 10px",
                          cursor: "pointer",
                          textDecoration: "none",
                          borderRadius: 8,
                          transition:
                            "background 0.12s ease, transform 0.08s ease, box-shadow 0.12s ease",

                          // ⭐ EXACT same background behavior as the FIRST BLOCK
                          // dragging → #F6255A background, white text
                          background: isDragTarget ? "#F6255A" : undefined,
                          color: isDragTarget ? "#ffffff" : undefined,

                          // ⭐ NEW: ONLY show dashed border on drag (from second block)
                          border: isDragTarget
                            ? "1px dashed #ffffff"
                            : "1px solid transparent",

                          // ❗ REMOVE lift and glow from first block
                          boxShadow: "none",
                          transform: "none",
                        }}
                      >
                        <span>{group.name}</span>

                        {/* Delete Icon */}
                        <span
                          onClick={e => {
                            e.stopPropagation()
                            setGroupToDelete(group.name)
                            setShowGroupDeleteModal(true)
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 640"
                            width="12"
                            height="12"
                            fill="currentColor"
                          >
                            <path
                              d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" />
                          </svg>
                        </span>
                      </a>
                    </li>
                  )
                })}

                {/* Create Group Button */}
                <li>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="secondary"
                      className="createGroupBtn"
                      id="createGroup-abcz082458wer"
                    >
                      {/* <i className="fa-solid fa-plus"></i> */}
                      <i className="fas fa-plus" style={{ marginRight: 8, fontSize: 12 }} aria-hidden="true"></i>
                      Create Group
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="p-0 border-0 m-0">
                      <div className="create_grp_popup">
                        <h6>Create Group</h6>
                        <input
                          value={createTag}
                          onChange={e => setCreateTag(e.target.value)}
                          type="text"
                          placeholder="Enter Group Name"
                        />
                        <div className="create_grp_popup_btn">
                          <button
                            onClick={async () => {
                              if (!createTag) return
                              document
                                .querySelector("#createGroup-abcz082458wer")
                                ?.click()

                              const newGroup = createTag
                              setCreateTag("")

                              try {
                                await createEmptyGroup(newGroup)
                              } catch (e) { }
                            }}
                            type="button"
                            className="active"
                          >
                            Create
                          </button>
                          <button
                            onClick={() => {
                              setCreateTag(null)
                              document
                                .getElementById("createGroup-abcz082458wer")
                                .click()
                            }}
                            type="button"
                            value="cancel"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>

              {/* Platform filter as pill tabs, matching Most Tracked Games /
                  Top Performer Apps on the home dashboard - single-select,
                  clicking the already-active platform clears back to "all". */}
              <div className="platform-filter-row">
                <PlatformTabs
                  variant="pill"
                  showDivider={false}
                  selected={selectedPlatform === "all" ? [] : [selectedPlatform]}
                  onToggle={handlePlatformToggle}
                />
              </div>

              <div className="select_grp_popup">
                <KeywordTrackingLandingPageModal
                  show={showModal}
                  handleClose={handleClose}
                  title="My Modal"
                  itemId={gameToMove?.item_id}
                  tagType="KEYWORD"
                >
                  <p>This is the modal content.</p>
                </KeywordTrackingLandingPageModal>
                <Link to="/keyword-tracking" className="go-back-btn"></Link>
              </div>

              <div className="row">
                {activeGroup && (
                  <div className="col-12 text-end mb-3">
                    <button
                      type="button"
                      onClick={() => {
                        pendingAddToGroupRef.current = activeGroup
                        setCreateTag(activeGroup)
                        setDetailsShowModal(true)
                      }}
                      style={{
                        background: "#F6255A",
                        color: "#fff",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: 8,
                        cursor: "pointer",
                      }}
                    >
                      Add to {activeGroup}
                    </button>
                  </div>
                )}
                {loading ? (
                  [...Array(skeletonCount || 3)].map((_, idx) => (
                    <div
                      key={idx}
                      className="col-sm-12 col-lg-12 col-xxl-12 col-md-6"
                    >
                      <SkeletonCard />
                    </div>
                  ))
                ) : isGuest ? (
                  <div className="col-12">
                    <GuestRestrictedPlaceholder 
                      height="400px"
                      subMessage="Sign in to track keywords and organize your favorite VR apps into custom groups."
                    />
                  </div>
                ) : sortedFilteredGames.length === 0 ? (
                  <div className="col-12 text-center" style={{ padding: "60px 20px" }}>
                    <div
                      style={{
                        background: "rgba(30, 31, 41, 0.6)",
                        borderRadius: "24px",
                        border: "1px solid rgba(255, 255, 255, 0.05)",
                        padding: "60px 40px",
                        maxWidth: "600px",
                        margin: "0 auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "24px",
                        backdropFilter: "blur(10px)",
                      }}
                    >
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "20px",
                          background: "rgba(246, 37, 90, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <Gamepad2 size={40} color="#F6255A" strokeWidth={1.5} />
                      </div>

                      <div>
                        <h4 style={{
                          color: "#fff",
                          fontSize: "24px",
                          fontWeight: "600",
                          marginBottom: "12px"
                        }}>
                          {activeGroup ? `No apps in "${activeGroup}"` : "No Tracked Apps Yet"}
                        </h4>
                        <p style={{
                          color: "#A1ACB8",
                          fontSize: "16px",
                          lineHeight: "1.6",
                          margin: 0,
                          maxWidth: "400px"
                        }}>
                          {activeGroup
                            ? "This group is currently empty. Add apps to this group to start monitoring them together."
                            : "Track your first app to start monitoring keywords and rankings. Insights will appear here once you start tracking."}
                        </p>
                      </div>

                      <button
                        onClick={() => {
                          setDetailsShowModal(true);
                        }}
                        style={{
                          background: "#F6255A",
                          color: "#fff",
                          border: "none",
                          padding: "12px 32px",
                          borderRadius: "12px",
                          fontSize: "16px",
                          fontWeight: "600",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          transition: "transform 0.2s ease, background 0.2s ease",
                          marginTop: "8px"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#e11d4c";
                          e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#F6255A";
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                      >
                        <Search size={18} />
                        {activeGroup ? "Add to Group" : "Track Your First App"}
                      </button>
                    </div>
                  </div>
                ) : (
                  // )
                  currentGames.map((game, idx) => (
                    <div
                      key={idx}
                      className="col-sm-12 col-lg-12 col-xxl-12 col-md-6"
                    >
                      <div
                        className="chart_inner_sec"
                        draggable
                        onDragStart={e => handleCardDragStart(e, game)}
                        onDragEnd={handleCardDragEnd}
                        onClick={e => {
                          if (game.is_locked) {
                            e.preventDefault()
                            e.stopPropagation()
                            setShowSubscriptionModal(true)
                          } else {
                            handleCardClick(e, game)
                          }
                        }}
                        style={{
                          cursor: game.is_locked ? "pointer" : "grab",
                          position: "relative",
                          filter: game.is_locked ? "blur(2px)" : "none",
                          opacity: game.is_locked ? 0.6 : 1
                        }}
                        title={game.is_locked ? "Upgrade your plan to access this app" : ""}
                      >
                        {game.is_locked && (
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              backgroundColor: "rgba(0, 0, 0, 0.8)",
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 10,
                              pointerEvents: "none"
                            }}
                          >
                            <i
                              className="fas fa-lock"
                              style={{
                                fontSize: "18px",
                                color: "#FFFFFF"
                              }}
                            />
                          </div>
                        )}
                        <div
                          className="char_inner_box"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 16,
                            width: "100%",
                          }}
                        >
                          <div
                            className="char_inner_box_lt"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 12,
                              minWidth: 0,
                              flex: "1 1 auto",
                            }}
                          >
                            <div className="char_inner_box_lt_img">
                              {game.is_locked ? (
                                <div
                                  onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    setShowSubscriptionModal(true)
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img src={game.image_url} alt={game.name} />
                                </div>
                              ) : (
                                <Link
                                  to="/xr/keyword"
                                  state={{ item_id: game.item_id }}
                                >
                                  <img src={game.image_url} alt={game.name} />
                                </Link>
                              )}
                            </div>
                            <div
                              className="char_inner_box_lt_text"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                minWidth: 0,
                                flex: "1 1 auto",
                              }}
                            >
                              <div
                                style={{
                                  minWidth: 0,
                                  fontSize: "clamp(14px, 2.2vw, 18px)",
                                  fontWeight: 600,
                                  color: "#fff",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "min(60vw, 220px)",
                                }}
                                title={game.name}
                                aria-label={game.name}
                              >
                                {game.name}
                              </div>
                              <p style={{ margin: 0, color: "#A1ACB8" }}>
                                <PlatformIcon platform={game.platform} size={16} />
                              </p>
                            </div>
                            <div
                              className="d-flex align-items-center gap-5"
                              style={{
                                background: "#1E1F29",
                                padding: "12px 18px",
                                borderRadius: "10px",
                                display: "inline-flex", // shrink to fit content
                                position: "relative",
                                flex: "0 0 auto",
                                whiteSpace: "nowrap",
                                gap: 20,
                              }}
                            >
                              {/* Tracked On */}
                              <div style={{ textAlign: "center" }}>
                                <div
                                  style={{ color: "#A1ACB8", fontSize: "12px" }}
                                >
                                  Tracked On
                                </div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    color: "#fff",
                                  }}
                                >
                                  {game.tracked_on
                                    ? new Date(
                                      game.tracked_on
                                    ).toLocaleDateString()
                                    : "--"}
                                </div>
                              </div>

                              {/* Keywords Count */}
                              <div style={{ textAlign: "center" }}>
                                <div
                                  style={{ color: "#A1ACB8", fontSize: "12px" }}
                                >
                                  Keywords
                                </div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    color: "#fff",
                                  }}
                                >
                                  {game.tracking_count || 0}
                                </div>
                              </div>

                              {/* Average Change */}
                              <div style={{ textAlign: "center" }}>
                                <div
                                  style={{ color: "#A1ACB8", fontSize: "12px" }}
                                >
                                  Avg Change
                                </div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    color:
                                      averageChange(game) > 0
                                        ? "#4ade80"
                                        : averageChange(game) < 0
                                          ? "#f87171"
                                          : "#fff",
                                  }}
                                >
                                  {averageChange(game)}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="char_inner_box_rt"
                            data-stop-card-click
                            style={{ flex: "0 0 auto", marginLeft: "auto" }}
                          >
                            <ul>
                              <li>
                                <Link
                                  className="active"
                                  to="/xr/keyword"
                                  state={{ item_id: game.item_id }}
                                  onClick={e => e.stopPropagation()}
                                >
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M21.75 12L22.3725 11.688V11.685L22.368 11.6805L22.359 11.6625L22.3275 11.6025L22.2075 11.3865C22.061 11.1339 21.9054 10.8868 21.741 10.6455C21.1921 9.83995 20.5613 9.09345 19.8585 8.41802C18.1695 6.79802 15.57 5.14502 12 5.14502C8.43295 5.14502 5.83195 6.79652 4.14295 8.41802C3.44015 9.09345 2.80927 9.83995 2.26045 10.6455C2.03776 10.9741 1.83151 11.3135 1.64245 11.6625L1.63345 11.6805L1.63045 11.685V11.6865C1.63045 11.6865 1.62895 11.688 2.25145 12L1.62895 11.6865C1.58082 11.7838 1.55579 11.8908 1.55579 11.9993C1.55579 12.1078 1.58082 12.2148 1.62895 12.312L1.62745 12.315L1.63195 12.3195L1.64095 12.3375C1.68773 12.4312 1.73776 12.5233 1.79095 12.6135C2.43685 13.7046 3.22697 14.7036 4.13995 15.5835C5.83045 17.2035 8.42995 18.8535 12 18.8535C15.5685 18.8535 18.1695 17.2035 19.86 15.582C20.5615 14.9058 21.1918 14.1594 21.741 13.3545C21.9513 13.0448 22.147 12.7255 22.3275 12.3975L22.359 12.3375L22.368 12.3195L22.371 12.315V12.3135C22.371 12.3135 22.3725 12.312 21.75 12ZM21.75 12L22.3725 12.3135C22.4206 12.2163 22.4456 12.1093 22.4456 12.0008C22.4456 11.8923 22.4206 11.7853 22.3725 11.688L21.75 12ZM11.91 9.69602C11.2989 9.69602 10.7129 9.93876 10.2808 10.3708C9.8487 10.8029 9.60595 11.389 9.60595 12C9.60595 12.6111 9.8487 13.1971 10.2808 13.6292C10.7129 14.0613 11.2989 14.304 11.91 14.304C12.521 14.304 13.107 14.0613 13.5391 13.6292C13.9712 13.1971 14.214 12.6111 14.214 12C14.214 11.389 13.9712 10.8029 13.5391 10.3708C13.107 9.93876 12.521 9.69602 11.91 9.69602ZM8.21695 12C8.21695 11.0198 8.60635 10.0797 9.29949 9.38655C9.99262 8.69342 10.9327 8.30402 11.913 8.30402C12.8932 8.30402 13.8333 8.69342 14.5264 9.38655C15.2196 10.0797 15.609 11.0198 15.609 12C15.609 12.9803 15.2196 13.9204 14.5264 14.6135C13.8333 15.3066 12.8932 15.696 11.913 15.696C10.9327 15.696 9.99262 15.3066 9.29949 14.6135C8.60635 13.9204 8.21695 12.9803 8.21695 12Z"
                                      fill="white"
                                    />
                                  </svg>
                                  <span className="hoverText">View</span>
                                </Link>
                              </li>
                              <li
                                onClick={e => {
                                  e.stopPropagation()
                                  handleOpen(game)
                                }}
                              >
                                <Link>
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0_91_3961)">
                                      <path
                                        d="M11.0016 9.99844H13.0031V5.00156H17.0016L12 0L6.99844 5.00156H10.9969V9.99844H11.0016ZM24 12L18.9984 6.99844V10.9969H14.0016V12.9984H19.0031V16.9969L24 12ZM9.99844 11.0016H5.00156V7.00312L0 12L5.00156 17.0016V13.0031H10.0031V11.0016H9.99844ZM12.9984 14.0016H10.9969V19.0031H6.99844L12 24L17.0016 18.9984H13.0031V14.0016H12.9984Z"
                                        fill="#A1ACB8"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_91_3961">
                                        <rect
                                          width="24"
                                          height="24"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <span className="hoverText">Move</span>
                                </Link>
                              </li>
                              <li
                                onClick={e => {
                                  e.stopPropagation()
                                  setGameToDelete(game)
                                  setShowDeleteModal(true)
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <Link>
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
                                      fill="#A1ACB8"
                                    />
                                  </svg>
                                  <span className="hoverText">Delete</span>
                                </Link>
                              </li>
                              {/* Modal moved outside loop */}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              {sortedFilteredGames.length > 0 && (
                <div
                  className="pagination"
                  style={{
                    marginTop: "30px",
                    marginBottom: activeGroup ? "40px" : "20px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  {/* Previous Button */}
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    style={{
                      background: currentPage === 1 ? "#2A2B38" : "#F6255A",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      fontWeight: 500,
                    }}
                  >
                    Prev
                  </button>

                  {/* Page Numbers */}
                  {Array.from(
                    { length: Math.ceil(sortedFilteredGames.length / itemsPerPage) },
                    (_, i) => i + 1
                  ).map(pageNum => (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      style={{
                        background: pageNum === currentPage ? "#F6255A" : "#2A2B38",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        padding: "6px 12px",
                        cursor: "pointer",
                        fontWeight: pageNum === currentPage ? 600 : 500,
                      }}
                    >
                      {pageNum}
                    </button>
                  ))}

                  {/* Next Button */}
                  <button
                    onClick={() =>
                      setCurrentPage(prev =>
                        Math.min(
                          prev + 1,
                          Math.ceil(sortedFilteredGames.length / itemsPerPage)
                        )
                      )
                    }
                    disabled={
                      currentPage === Math.ceil(sortedFilteredGames.length / itemsPerPage)
                    }
                    style={{
                      background:
                        currentPage ===
                          Math.ceil(sortedFilteredGames.length / itemsPerPage)
                          ? "#2A2B38"
                          : "#F6255A",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      cursor:
                        currentPage ===
                          Math.ceil(sortedFilteredGames.length / itemsPerPage)
                          ? "not-allowed"
                          : "pointer",
                      fontWeight: 500,
                    }}
                  >
                    Next
                  </button>
                </div>
              )}

            </div>

            {showCreateGroupModal && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1000,
                }}
              >
                <div
                  style={{
                    background: "#21222D",
                    borderRadius: "12px",
                    padding: "24px",
                    width: "90%",
                    maxWidth: "400px",
                    color: "#FFFFFF",
                    fontFamily: "Rubik, sans-serif",
                  }}
                >
                  <h4 style={{ marginBottom: "16px", fontWeight: "600" }}>
                    Create Group
                  </h4>

                  <input
                    type="text"
                    placeholder="Enter Group Name"
                    value={groupNameInput}
                    onChange={e => setGroupNameInput(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 16px",
                      marginBottom: "24px",
                      borderRadius: "6px",
                      border: "none",
                      background: "#171821",
                      color: "#fff",
                    }}
                  />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "12px",
                    }}
                  >
                    <button
                      onClick={() => setShowCreateGroupModal(false)}
                      style={{
                        background: "#171821",
                        color: "#FFFFFF",
                        border: "none",
                        borderRadius: "6px",
                        padding: "10px 16px",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      onClick={async () => {
                        if (!groupNameInput) return
                        setCreatedGroupName(groupNameInput)
                        setShowCreateGroupModal(false)
                        setGroupNameInput("")
                        pendingAddToGroupRef.current = groupNameInput
                        try {
                          await createEmptyGroup(groupNameInput)
                        } catch (e) { }
                        setIsModalOpen(true)
                        setShowAppSearchModal(true)
                      }}
                      style={{
                        background: "#F6255A",
                        color: "#FFFFFF",
                        border: "none",
                        borderRadius: "6px",
                        padding: "10px 16px",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      Create
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showGroupDeleteModal && groupToDelete && (
              <div
                style={{
                  position: "fixed",
                  left: 0,
                  top: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0,0,0,0.55)",
                  zIndex: 12345,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    background: "#21222D",
                    color: "#fff",
                    borderRadius: 16,
                    padding: 32,
                    maxWidth: 340,
                    width: "100%",
                    textAlign: "center",
                    boxShadow: "0 4px 32px #0007",
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 8 }}>
                    Delete group "{groupToDelete}"?
                  </div>
                  <div style={{ color: "#A1ACB8", marginBottom: 24 }}>
                    Are you sure you want to remove this group? This action can’t
                    be undone.
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "center", gap: 16 }}
                  >
                    <button
                      style={{
                        background: "#171821",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8,
                        padding: "10px 22px",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                      onClick={() => setShowGroupDeleteModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      style={{
                        background: "#F6255A",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8,
                        padding: "10px 22px",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setShowGroupDeleteModal(false) // close modal
                        await handleRemoveGroup(groupToDelete) // call API
                        setGroupToDelete(null) // reset
                      }}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <AppSearchModal
            modaltoggle={isModalOpen}
            togglemodal={() => setIsModalOpen(!isModalOpen)}
            onAppSelect={async app => {
              try {
                setIsModalOpen(false)
                // If a create-flow had set a createdGroupName, attach this app to that new group
                if (createdGroupName) {
                  const gameWithGroup = {
                    tag_name: createdGroupName,
                    item_id: app.item_id,
                  }
                  await createGroupApi(gameWithGroup)
                  setCreatedGroupName("")
                  pendingAddToGroupRef.current = null
                  return
                }

                // If there is a pending target group (from Add button), add the selected app into it
                if (pendingAddToGroupRef.current) {
                  const target = pendingAddToGroupRef.current
                  pendingAddToGroupRef.current = null
                  try {
                    // await ensureAppTracked(app.item_id)
                    await createNewGameTag(app.item_id, target)
                    trackEvent(ANALYTICS_EVENTS.FEATURE.KEYWORD_TRACKING_APP_ADDED, {
                      app_id: app.item_id,
                      app_name: app.name,
                      keyword_group: target,
                    })
                    await getGameTags()
                    // await callAppTrackapi()
                  } catch (err) {
                    console.error("Add-to-pending-group failed", err)
                    if (isUpgradeError(err)) setShowUpgradeModal(true)
                  }
                  return
                }

                // Default behavior: go to keyword details so user can track/select keywords there
                navigate(`/xr/keyword/${(app.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}?id=${app.item_id}`, { state: { item_id: app.item_id } })
              } catch (err) {
                console.error("AppSelect handler failed", err)
                if (isUpgradeError(err)) setShowUpgradeModal(true)
              }
            }}
            alreadySelectedApps={alreadySelectedGames}
            type="Keyword"
          />
          <KeywordTrackingDetailsModal
            show={showDetailsModal}
            handleClose={() => {
              setCreateTag("")
              setDetailsShowModal(false)
            }}
            title={createTag ? "Select an App to Create Group" : "Select an App"}
            searchTerm={searchTerm}
            onSearchChange={e => setSearchTerm(e.target.value)}
            onSearchClick={handleSearch}
            results={searchResults}
            loading={loading} // <-- pass loading state here
            // Add-to-tag props (align behavior with AppTrackingv2)
            createTag={createTag}
            trackedIds={trackedIds}
            tags={groups}
            onAddToTag={handleAddSingleToTag}
            onBulkAddToTag={handleBulkAddToTag}
            onRemoveFromTag={handleModalRemoveFromTag}
            onOpenGroup={(groupName) => {
              try { setDetailsShowModal(false) } catch (e) { }
              try { setActiveGroup(groupName) } catch (e) { }
            }}
            onSelectApp={handleselectedapp}
            onUpgrade={() => {
              setShowUpgradeModal(true)
              setDetailsShowModal(false)
              setSearchResults([])
            }}
          />

          {/* Upgrade Modal */}
          <AppsTrackingPlanModal
            show={showUpgradeModal}
            handleClose={() => setShowUpgradeModal(false)}
            title="Upgrade your plan to unlock this feature"
          />

          {/* Subscription Modal for Locked Apps */}
          <AppsTrackingPlanModal
            show={showSubscriptionModal}
            handleClose={() => setShowSubscriptionModal(false)}
            title="Upgrade your plan to access this app"
          />

          {showDeleteModal && gameToDelete && (
            <ConfirmRemoveTagModal
              show={showDeleteModal}
              onClose={() => {
                setShowDeleteModal(false)
                setGameToDelete(null)
              }}
              onConfirm={async ({ removeFromEverywhere }) => {
                setShowDeleteModal(false)
                if (!gameToDelete) return

                // Logic: if we have an active group and user didn't check "remove from everywhere",
                // we only remove from that group. Otherwise, we untrack globally.

                const isInGroup = activeGroup && activeGroup !== "all"

                if (isInGroup && !removeFromEverywhere) {
                  // Remove from this group only
                  await deleteGamefromTag(gameToDelete.item_id, activeGroup)
                  triggerToast(`Removed from ${activeGroup}`)
                } else {
                  // Remove from tracking entirely
                  await handleRemoveGame(gameToDelete)
                  triggerToast("Removed from tracking")
                  // If we were in a group, we should also refresh the group tags so UI updates
                  if (isInGroup) {
                    await getGameTags()
                  }
                }
                setGameToDelete(null)
              }}
              itemName={gameToDelete.name}
              tagName={
                activeGroup && activeGroup !== "all" ? activeGroup : null
              }
            />
          )}

          <style>{`
    .go-to-publisher-btn {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      background: linear-gradient(90deg, #4b5563 0%, #374151 100%);
      border: 1px solid rgba(255,255,255,0.06);
      color: #fff;
      padding: 10px 18px;
      border-radius: 999px;
      font-weight: 700;
      font-size: 14px;
      cursor: pointer;
      box-shadow: 0 6px 16px rgba(0,0,0,0.35);
      transition: transform 120ms ease, box-shadow 120ms ease, opacity 120ms ease;
      position: relative;
    }
    .go-to-publisher-btn:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 12px 24px rgba(0,0,0,0.36), 0 6px 20px rgba(255,255,255,0.02);
    }
    .go-to-publisher-btn:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
    .go-to-publisher-btn .go-icon { display: inline-block; flex: 0 0 auto; }
    .go-to-publisher-btn .go-label { display: inline-block; }
    .go-to-publisher-btn .go-loading { display: inline-block; }
  `}</style>
        </div >
      </div >
    </React.Fragment >
  )
}

export default KeywordTrackingLandingPage
